module.exports = __webpack_public_path__ + "static/img/img-home-co-03.0afa4c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-03.png
// module id = QSuq
// module chunks = 1